const requireModule = require.context('.', true, /\.vue$/)
import { i18n } from '@/i18n'

const data = requireModule
  .keys()
  .sort()
  .filter(fileName => {
    if (fileName.endsWith('index.js')) return false
    return true
  })

export default function () {
  return data
    .reduce((res, fileName) => {
      const module = requireModule(fileName)
      if (module.meta.skip) return res

      res.push({
        order: module.meta.order,
        component: module.default,
        id: module.meta.id,
        label: i18n.tc(module.meta.label, 2),
        icon: module.meta.icon,
      })

      return res
    }, [])
    .sort((a, b) => a.order - b.order)
}
